import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';

// ============================================
// REGISTRO DEL SERVICE WORKER (PWA)
// ============================================

const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/tavpos/sw.js', { scope: '/tavpos' })
        .then((registration) => {
          console.log('[SW] Registrado correctamente, scope:', registration.scope);
          registration.update();
        })
        .catch((error) => {
          console.warn('[SW] Registro fallido (no afecta la app):', error);
        });
    });
  }
};

registerServiceWorker();

// ============================================
// INICIALIZAR REACT
// ============================================

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/tavpos">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);